import type { agg } from './logic';

export const aggregateConfidenceExplanation =
  'Most predicted travellers come from departures in this tier. This is the traveller-weighted most common tier, not a confidence score for the total.';

export function confidenceSplit(mix: ReturnType<typeof agg>['confidenceMix']): string {
  const shares = [...mix]
    .filter((item) => item.predictedPax > 0)
    .sort((a, b) => b.predictedPax - a.predictedPax)
    .map((item) => `${item.tier.charAt(0).toUpperCase()}${item.tier.slice(1)} ${Math.round(item.paxShare * 100)}%`);
  return shares.length ? `${shares.join(' · ')} of predicted travellers` : '';
}

export function aggregateConfidenceTooltip(mix: ReturnType<typeof agg>['confidenceMix']): string {
  const split = confidenceSplit(mix);
  return split ? `${aggregateConfidenceExplanation}\n${split}` : aggregateConfidenceExplanation;
}
